<script lang="ts" module>
import type { InjectionKey } from "vue"

export const variantTextColorClassKey: InjectionKey<string> = Symbol()
</script>

<script setup lang="ts">
type AlertVariant = "warning" | "default" | "error" | "light" | "success"

const { variant = "default", animateIn = false } = defineProps<{
  variant?: AlertVariant
  animateIn?: boolean
}>()

const baseClasses = "flex gap-2.5 rounded-lg border p-3"

const variantClasses = computed(() => {
  const variants: Record<AlertVariant, string> = {
    warning: "border-amber-500/20 bg-amber-50/50",
    error: "bg-rose-50 border-rose-200",
    default: "bg-zinc-50 border-zinc-200",
    light: "bg-white border-zinc-200",
    success: "border-emerald-200 bg-emerald-50",
  }

  return `${baseClasses} ${variants[variant]}`
})

const variantTextColorClass = computed(() => {
  const variants: Record<AlertVariant, string> = {
    warning: "text-amber-800",
    error: "text-rose-600",
    default: "text-zinc-500",
    light: "text-zinc-500",
    success: "text-emerald-700",
  }

  return variants[variant]
})

provide(variantTextColorClassKey, variantTextColorClass.value)
</script>

<template>
  <Transition
    enter-active-class="transition-all duration-250 ease-out"
    leave-active-class="transition-all duration-250 ease-out"
    enter-from-class="opacity-0 scale-95"
    enter-to-class="opacity-100 scale-100"
    leave-from-class="opacity-100 scale-100"
    leave-to-class="opacity-0 scale-95"
    :appear="animateIn"
  >
    <div :class="variantClasses">
      <slot />
    </div>
  </Transition>
</template>
